module.exports = __webpack_public_path__ + "static/media/footer-bg.242e7471.webp";